import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function FlawlessIllustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3781" data-mp="2mw2sg5an6iw2">
      <div className="relative w-full h-full bg-gradient-to-b from-sky-200 to-indigo-300 overflow-hidden" data-id="element-3782" data-mp="2dvxne1sx7wl2">
        {/* Background: Sparkle field */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3783" data-mp="28xmdxs6jfo3d">
          <circle cx="100" cy="95" r="72" fill="#E0E7FF" opacity="0.5" data-id="element-3784" data-mp="75q2sjoa8g94" />
          <path d="M45 55 L48 64 L57 67 L48 70 L45 79 L42 70 L33 67 L42 64 Z" fill="#FFFFFF" data-id="element-3785" data-mp="26dfjxti1760" />
          <path d="M158 70 L160 76 L166 78 L160 80 L158 86 L156 80 L150 78 L156 76 Z" fill="#FFFFFF" data-id="element-3786" data-mp="34l67hdlmugkb" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[8%]" data-id="element-3787" data-mp="2un8dsal07rkb">
          <div className="w-[64%] h-[64%] flex items-center justify-center" data-id="element-3788" data-mp="2zmbgvphfbnpn">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3789" data-mp="2zml5p9qqfotr" />
          </div>
        </div>

        {/* Foreground: 10 perfect marks + big sparkle */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3790" data-mp="3ijcprle3m7yv">
            <path d="M100 24 L104 40 L120 44 L104 48 L100 64 L96 48 L80 44 L96 40 Z" fill="#FDE047" stroke="#CA8A04" strokeWidth="1" data-id="element-3791" data-mp="ey6umwjh5as6" />
            <path d="M-10 155 Q100 178 210 155 L210 200 L-10 200 Z" fill="#4338CA" opacity="0.8" data-id="element-3792" data-mp="jr6om5t7d9la" />
            <text x="100" y="186" textAnchor="middle" fontFamily="sans-serif" fontSize="18" fontWeight="900" fill="white" data-id="element-3793" data-mp="ar9wfu7ltslh">
              10 perfect
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}